<input currencyMask inputmode="numeric" [(ngModel)]="value" class="form-control" [disabled]="disabled" (ngModelChange)="onChange($event)" />